import type { ObjectDirective } from 'vue';

/**
 * Directive to move the tooltip overlay to the dialog element
 * when wb tooltip is open.
 */
export const vWbtooltip: ObjectDirective<HTMLElement> = {
  mounted(el, binding) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(() => {
        if (el.hasAttribute('open')) {
          const dialogEl = el.closest('dialog');
          if (!dialogEl) return;

          const tooltipId = el.getAttribute('aria-labelledby');
          if (!tooltipId) return;

          const tooltipOverlay = document.getElementById(tooltipId);
          if (!tooltipOverlay) return;

          dialogEl.appendChild(tooltipOverlay);
        }
      });
    });

    observer.observe(el, {
      attributes: true,
      attributeFilter: ['open'],
    });

    binding.dir.beforeUnmount = () => {
      observer.disconnect();
    };
  },
};
